export const EBONY_CLAY = '#2A2E42';
export const SILVER_CHALICE = '#ABABAB';
export const ROSE = '#FF0068';
export const ROSE_SHADE = '#CC0053';
export const PAUA_BLUE = '#191357';
export const WHITE = '#FFFFFF';
export const GRAY90 = '#e5e5e5';
export const LOGAN = '#c5c4d5';
export const BLUE = '#0251ff';
export const CHECK_GREEN = '#38ad54';
export const ALERT_RED = '#f44336';
export const MID_GRAY = '#555868';
export const DOVE_GRAY = '#666666';
export const GRAPHITE = '#687188';
export const DARK = '#333333';
